
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'crm-index-ui',
  currentProjectVersion: 'static-2.46503',
  depVersions: {
  "crm-index-ui": "static-2.46503",
  "ably-hubspot-js": "static-1.435",
  "apollo-dlb": "static-3.41",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.3048",
  "calling-orchestration-shared-library": "static-1.29616",
  "card-associated-objects-lib": "static-1.38105",
  "card-associated-objects-lib-legacy": "static-1.5736",
  "client-types": "static-1.370",
  "commerce-contract-lib": "static-1.5396",
  "commerce-products-lib": "static-1.4257",
  "commerce-shared-components-lib": "static-1.14256",
  "commerce-tools-ui-lib": "static-1.6002",
  "commerce-tours-lib": "static-1.3145",
  "contextual-settings-lib": "static-1.1522",
  "credit-memos-ui-lib": "static-1.5587",
  "crm_data": "static-4.86185",
  "crm-cards-global-registry": "static-1.14099",
  "crm-common-dlb": "static-1.3941",
  "crm-component-utils": "static-1.33944",
  "crm-index-associations-lib": "static-1.4996",
  "crm-index-visualization-core": "static-1.2523",
  "crm-legacy-global-containers": "static-1.22429",
  "crm-legacy-links": "static-1.71071",
  "crm-message-bus": "static-1.35918",
  "crm-object-board-core": "static-1.12106",
  "crm-object-gantt": "static-1.2085",
  "crm-object-map": "static-1.1543",
  "crm-object-search-query-utilities": "static-1.5908",
  "crm-object-search-query-utilities-test-utils": "static-1.5570",
  "crm-pipeline-board-settings-lib": "static-1.25156",
  "crm-pipelines-api-client-types": "static-1.2973",
  "customer-data-bulk-actions": "static-1.29405",
  "customer-data-objects": "static-1.6217",
  "customer-data-objects-ui-components": "static-1.11508",
  "customer-data-properties": "static-1.45010",
  "customer-data-sidebar": "static-2.40281",
  "customer-data-views-management": "static-1.21806",
  "data-fetching-client": "static-1.8233",
  "data-privacy-hub-settings-service-types": "static-1.2836",
  "demographics-client": "static-1.4042",
  "dispatcher": "static-1.111",
  "embedded-academy-lib": "static-1.9728",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.293",
  "external-options-client-types": "static-1.2939",
  "feedback-loader": "static-1.26244",
  "foundations-components": "static-1-gcm-text-color-inherit.6",
  "foundations-components-test-utils": "static-1-gcm-text-color-inherit.6",
  "foundations-theming": "static-1.2934",
  "foundations-theming-specialty": "static-1.651",
  "framework-data-schema-quick-fetch": "static-1.5386",
  "framework-data-schema-resolvers": "static-1.5481",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.6933",
  "framework-data-table": "static-2.8248",
  "general-store": "static-6.20",
  "googlemaps-react-wrapper": "static-1.3",
  "growth-onboarding-beacon": "static-1.2280",
  "growth-payments-core": "static-1.20584",
  "head-dlb": "static-1.3679",
  "highcharts": "static-8.80",
  "history": "static-4.47",
  "hs-promise-utils": "static-1.4136",
  "hs-test-utils": "static-1.6627",
  "hub-http": "static-1.4807",
  "hubspot-apollo-client": "static-1.3448",
  "hubspot-dlb": "static-2.1317",
  "HubStyleTokens": "static-2.10112",
  "I18n": "static-7.1372",
  "immer": "static-1.33",
  "immutable": "static-2.19",
  "inbound-db-meta-service-client": "static-1.2626",
  "inbound-db-properties-service-client": "static-1.2797",
  "inbounddb-objects-service-types": "static-1.3062",
  "jasmine-immutable": "static-1.1581",
  "jasmine-runner": "static-1.5022",
  "laboratory-lib": "static-3.5880",
  "lodash": "static-1.3",
  "marketing-event-attendance-cards-ui": "static-1.4590",
  "marketplace-embed": "static-1.15702",
  "marketplace-ui-client-types": "static-1.10872",
  "object-builder-ui-client": "static-1.41204",
  "onboarding-scopes": "static-1.5165",
  "onboarding-tours": "static-1.13933",
  "payments-zero-states-lib": "static-1.14011",
  "pipeline-validation-client-types": "static-1.2727",
  "PortalIdParser": "static-2.272",
  "products-iframe-lib": "static-1.2287",
  "products-ui-components": "static-1.34777",
  "property-management-iframe": "static-1.7778",
  "quartz": "static-1.5375",
  "quick-fetch": "static-1.2832",
  "raven": "static-3.4440",
  "react": "static-7.151",
  "react-dlb": "static-1.51",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-4.5",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15223",
  "react-router-dom": "static-5.26",
  "react-utils": "static-2.4180",
  "recording-review-components-lib": "static-1.25785",
  "reference-resolvers-lite": "static-1.6578",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.6993",
  "reporting-data": "static-1.60967",
  "reporting-dlb": "static-1.53885",
  "reporting-testing-lib": "static-1.2902",
  "reporting-visualizations": "static-1.53045",
  "sales-views-client-types": "static-1.2970",
  "self-service-api": "static-1.8814",
  "settings-ui-lib": "static-1.11185",
  "signup-constants": "static-1.15864",
  "styled-components": "static-2.40",
  "superstore": "static-1.3405",
  "svh-onboarding-config-shared-lib": "static-1.2012",
  "tinymce": "static-6.5",
  "transmute": "static-2.29",
  "trial-components-library": "static-1.10613",
  "ui-addon-draggable": "static-2.1196",
  "ui-addon-integrations-directory-panel": "static-2.6610",
  "ui-addon-upgrades": "static-9.15772",
  "ui-components-test-utils": "static-1.4252",
  "UIComponents": "static-3.7061",
  "usage-based-billing-components-lib": "static-1.3003",
  "usage-tracker-core": "static-1.5938",
  "user-context": "static-1.3779",
  "webpack-env": "static-1.54",
  "wootric-nps": "static-1.5580",
  "account-and-billing-components": "static-1.16094",
  "account-and-billing-fintech-outages": "static-3.14844",
  "accounting-extension-card-ui": "static-1.30798",
  "accounting-integrations-ui-components": "static-1.4586",
  "ai-components-ui-library": "static-1.4991",
  "apollo-link-hub-http": "static-2.3411",
  "attribution-sidebar-cards": "static-1.38583",
  "BizOpsCrmUIComponents": "static-1.39929",
  "call-widget-addon": "static-2.26906",
  "calling-integration-sdk-support": "static-1.25050",
  "calling-integration-timeline-event": "static-1.12750",
  "calling-internal-common": "static-1.29819",
  "calling-lifecycle-internal": "static-1.58179",
  "calling-ui-library": "static-1.64098",
  "card-biz-ops-customer-success-lib": "static-1.71102",
  "card-biz-ops-domain-controls-lib": "static-1.71103",
  "card-biz-ops-related-contacts-lib": "static-1.71102",
  "card-crm-attribution-lib": "static-1.49375",
  "card-deal-collaborators-lib": "static-1.32181",
  "card-deal-shared-view-lib": "static-1.63017",
  "card-engagement-attachments-lib": "static-1.67357",
  "card-gdpr-subscriptions-card-lib": "static-1.41453",
  "card-integration-card-lib": "static-1.67418",
  "card-linked-in-sales-navigator-lib": "static-1.35037",
  "card-lists-lib": "static-1.65576",
  "card-past-conversations-lib": "static-1.31981",
  "card-payment-history-lib": "static-1.30969",
  "card-playbooks-lib": "static-1.57643",
  "card-preview-highlight-lib": "static-1.69622",
  "card-profile-products-lib": "static-1.51129",
  "card-profile-quotes-lib": "static-1.78330",
  "card-properties-lib": "static-1.38144",
  "card-sales-activities-timeline": "static-1.32259",
  "card-target-account-lib": "static-1.67068",
  "card-website-activity-lib": "static-1.67883",
  "chatspot-widget-iframe": "static-1.14839",
  "collaboration-sidebar": "static-1.51614",
  "commerce-billing-lib": "static-1.14142",
  "commerce-subscription-cards-lib": "static-1.25351",
  "commerce-subscription-lib": "static-1.30526",
  "composer-plugins": "static-1.66149",
  "conversations-thread-view-crm-events": "static-1.28844",
  "copilot-toolkit": "static-1.5603",
  "credit-memos-iframe-lib": "static-1.5589",
  "crm_components": "static-3.86185",
  "crm_schema": "static-3.86222",
  "crm_ui": "static-5.86143",
  "crm_universal": "static-1.20356",
  "crm-activity-creator-interaction-window": "static-1.40062",
  "crm-activity-creator-interactions-legacy": "static-1.30531",
  "crm-activity-creator-widgets": "static-1.46113",
  "crm-associations-table": "static-1.35793",
  "crm-cards": "static-1.38699",
  "crm-cards-sdk": "static-1.37402",
  "crm-command-handler": "static-1.29986",
  "crm-display-components": "static-1.19694",
  "crm-events-components": "static-1.54765",
  "crm-events-data": "static-1.54778",
  "crm-fe-perf": "static-1.21609",
  "crm-index-ui-toolbar": "static-1.1752",
  "crm-index-view-table-edit-columns-modal": "static-1.15483",
  "crm-index-visualization-toolbar": "static-1.2177",
  "crm-index-visualization-toolbar-test-utils": "static-1.1548",
  "crm-links": "static-1.4744",
  "crm-object-board": "static-1.22027",
  "crm-object-board-card": "static-1.12102",
  "crm-object-preview": "static-1.20746",
  "crm-object-table": "static-1.16909",
  "crm-timeline": "static-1.83105",
  "crm-timeline-tasks": "static-1.32099",
  "cropperjs": "static-1.10",
  "cssUtils": "static-1.459",
  "customer-data-board": "static-1.19162",
  "customer-data-board-card": "static-1.19123",
  "customer-data-bulk-actions-container": "static-1.15116",
  "customer-data-communicator": "static-1.39552",
  "customer-data-email": "static-1.15526",
  "customer-data-filters-ui": "static-1.33110",
  "customer-data-property-utils": "static-1.6544",
  "customer-data-reference-ui-components": "static-1.11606",
  "customer-data-rte": "static-1.28481",
  "customer-data-ui-utilities": "static-1.8359",
  "deal-registration-ui": "static-1.29550",
  "deal-splits-cards-ui": "static-1.38975",
  "deal-splits-sidebar": "static-1.38881",
  "draft-email-branding-plugin": "static-2.19728",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.18989",
  "draft-signature-plugin": "static-1.19476",
  "email-confirm-ui": "static-2.4262",
  "EmailSignatureEditor": "static-1.20073",
  "ExportDialog": "static-6.9022",
  "ExtensionInstallHelpers": "static-1.526",
  "file-manager-components": "static-1.17781",
  "FileManagerLib": "static-1.33422",
  "flywheel-feedback-panel-components": "static-1.5901",
  "foundations-assets": "static-1.3540",
  "framework-app-settings-features-lib": "static-1.3670",
  "frontend-preferences-client": "static-1.6500",
  "getting-started-shared-tasks": "static-1.11518",
  "graphql": "static-1.58",
  "growth-data-modal": "static-1.3822",
  "growth-feature-usage-components": "static-1.4130",
  "growth-feature-usage-data": "static-1.4349",
  "growth-onboarding-empty-states": "static-1.3796",
  "HeadJS": "static-2.563",
  "hubspot-prosemirror": "static-1.13076",
  "hubspot-url-utils": "static-1.2969",
  "HubStyle": "static-2.10421",
  "icons": "static-2.591",
  "in-meeting-experience-ui-components": "static-1.16425",
  "InboxConnectUtils": "static-4.9282",
  "integration-settings-components": "static-1.10081",
  "integrations-directory-panel-lib": "static-1.7449",
  "invoices-card-lib": "static-1.51080",
  "invoices-iframe-lib": "static-1.51009",
  "invoices-ui-lib": "static-1.48951",
  "lead-tracking-lib": "static-1.33227",
  "marketing-contacts-lib": "static-1.7757",
  "marketing-contacts-ui": "static-1.6267",
  "marketing-event-cards-ui": "static-1.31216",
  "marketplace-ui-apps-core": "static-1.12002",
  "marketplace-ui-common": "static-1.13466",
  "metrics-js": "static-1.8343",
  "mobile-manifest-mixins": "static-1.334",
  "native-integrations-shared-strings": "static-1.6450",
  "nav-meta": "static-1.25166",
  "object-comments-thread-lib": "static-1.5598",
  "onboarding-tours-client": "static-1.3134",
  "orders-card-lib": "static-1.16367",
  "panel-deal-registration-ai-summary-lib": "static-1.21953",
  "partner-shared-view-ui": "static-1.41863",
  "playbooks-modal": "static-1.74816",
  "playlists-lib": "static-1.6409",
  "products-highlight-card-lib": "static-1.12542",
  "property-translator": "static-1.4003",
  "quartz-core": "static-1.4594",
  "quotes-ui-lib": "static-1.73522",
  "react-beautiful-dnd": "static-1.13",
  "react-colorpicker": "static-2.8853",
  "react-immutable-render-mixin": "static-1.9",
  "react-select-plus": "static-1.65",
  "recent-activities-card": "static-1.52629",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reference-resolvers": "static-1.6774",
  "reporting-action-components": "static-1.35552",
  "reporting-crm-object-table": "static-1.2136",
  "reporting-enablement": "static-1.16328",
  "reporting-ui-components": "static-2.58246",
  "reselect": "static-2.16",
  "rich-text-lib": "static-1.17161",
  "rpc-client-utils": "static-1.3352",
  "SalesContentIndexUI": "static-3.6838",
  "salesforce-sync-card-ui": "static-1.7566",
  "sanitize-text": "static-1.6813",
  "sequences-lib": "static-1.5655",
  "SharedI18nStrings": "static-1.162",
  "subscriptions-components": "static-1.40751",
  "svh-conversations-settings-lib": "static-1.2012",
  "tasks-lib": "static-1.32173",
  "timezone-utils": "static-2.3887",
  "transcript-sidebar": "static-1.61858",
  "trellis-ecosystem": "static-1.4315",
  "ui-addon-avatars": "static-2.8059",
  "ui-addon-form-validation": "static-1.9650",
  "ui-addon-i18n": "static-1.9537",
  "ui-addon-iframeable": "static-1.7521",
  "ui-addon-opt": "static-4.7281",
  "ui-addon-react-router-dom": "static-1.8238",
  "ui-addon-scriptloader": "static-1.11003",
  "ui-addon-teams": "static-1.19513",
  "ui-asset-management-lib": "static-1.8822",
  "ui-business-units-lib": "static-1.7499",
  "ui-gdpr-components": "static-1.8879",
  "ui-shepherd-react": "static-3.8670",
  "ui-universal-auth": "static-1.7420",
  "usage-tracker": "static-1.6088",
  "usage-tracker-container": "static-1.6078",
  "atom": "static-1.3865",
  "hs-lodash": "static-4.45",
  "planout": "static-5.12",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "sanitize": "static-1.2997",
  "hs-promise-rejection-tracking": "static-1.3967",
  "raven-hubspot": "static-1.4747",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.2294",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.1652",
  "quartz-webpack": "static-1.1599",
  "ably": "static-1.18",
  "calling-orchestration-schema": "static-1.29841",
  "avatar-components": "static-1.1032",
  "calling-global-api": "static-1.56797",
  "campaigns-lib": "static-1.21552",
  "card-payment-highlight-lib": "static-1.31104",
  "customer-data-tracking": "static-1.5432",
  "payment-link-components": "static-1.17905",
  "payments-embed-points-lib": "static-1.8974",
  "persist-promise": "static-1.2368",
  "PatternValidationJS": "static-1.437",
  "usage-tracker-session-replay": "static-1.2954",
  "utility-belt": "static-1.1201",
  "products-ui-components-shared-msw-handlers": "static-1.7232",
  "hs-story-utils": "static-1.8015",
  "msw": "static-1.39",
  "payments-enrollment-embed-lib": "static-1.17073",
  "StyleGuideUI": "static-3.453",
  "ui-images": "static-2.805",
  "cv-backend-services": "static-1.1110",
  "growth-onboarding-confetti": "static-1.1729",
  "payments-post-enroll-local-storage-lib": "static-1.3710",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.43",
  "react-dnd-compat": "static-1.3269",
  "magpie-lib": "static-1.4304",
  "magpie-types": "static-1.3764",
  "adobe-sign-cards-lib": "static-1.12481",
  "ai-addon-copilot-preview": "static-1.4203",
  "automation-ui-crm-card-workflows-invoker": "static-1.4583",
  "buyer-intent-card": "static-1.15637",
  "card-call-summaries-lib": "static-1.29682",
  "card-company-summary-lib": "static-1.13292",
  "card-customer-spend-trends-lib": "static-1.20571",
  "card-flywheel-activity-history-lib": "static-1.1780",
  "card-flywheel-company-overview-lib": "static-1.10809",
  "card-flywheel-domain-review-history-lib": "static-1.437",
  "card-flywheel-high-intent-associated-contacts-lib": "static-1.10809",
  "card-guest-access-management-lib": "static-1.2396",
  "card-guided-execution-activities": "static-1.3780",
  "card-knowledge-base-lib": "static-1.6712",
  "card-lead-insights": "static-1.8947",
  "card-lead-qualification-lib": "static-1.24565",
  "card-object-highlight-lib": "static-1.1083",
  "card-object-summary-lib": "static-1.2742",
  "card-other-tickets-lib": "static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "static-1.25396",
  "card-partner-client-unified-usage-score-lib": "static-1.19761",
  "card-prospecting-research-agent": "static-1.1835",
  "card-tasks-timeline-lib": "static-1.9577",
  "card-ticket-summary-lib": "static-1.11424",
  "crm-actions": "static-1.4684",
  "crm-associations-pivot": "static-1.33923",
  "crm-clv-report": "static-1.2581",
  "crm-data-highlights": "static-1.36331",
  "crm-events-viz-cards": "static-1.35585",
  "crm-events-viz-totals": "static-1.27138",
  "crm-extension": "static-1.35651",
  "crm-pipeline-approvals-lib": "static-1.18605",
  "crm-properties-list": "static-1.32969",
  "crm-property-history": "static-1.11029",
  "crm-quick-actions": "static-1.12479",
  "crm-relative-timeline": "static-1.12907",
  "crm-report": "static-1.36538",
  "crm-simple-deadline": "static-1.13125",
  "crm-stage-tracker": "static-1.31502",
  "crm-statistics": "static-1.25547",
  "custom-events-card-lib": "static-1.292",
  "customer-overview-card-lib": "static-1.4155",
  "customer-success-contacts-card-lib": "static-1.12261",
  "deal-summary-components": "static-1.15120",
  "docusign-cards-lib": "static-1.21988",
  "flywheel-growth-plans-crm-card": "static-1.1303",
  "guided-actions-card": "static-1.8816",
  "guided-selling-stage-tracker-card": "static-1.5942",
  "health-score-card-lib": "static-1.15544",
  "help-desk-insights-lib-crm-cards": "static-1.17750",
  "intelligence-overview-card": "static-1.9469",
  "intelligence-overview-lib": "static-1.7720",
  "invoices-history-card-lib": "static-1.25364",
  "lead-scores-card": "static-1.11924",
  "legacy-sidebar-card-lib": "static-1.29137",
  "payment-schedule-card-lib": "static-1.22716",
  "playbooks-card": "static-1.37526",
  "predictive-scores-card": "static-1.25112",
  "process-guide-cards": "static-1.3368",
  "products-cards-lib": "static-1.3851",
  "purchase-history-lib": "static-1.15053",
  "ui-google-drive-attachments": "static-1.1159",
  "ui-google-drive-insights": "static-1.1161",
  "customer-data-properties-shared-msw-handlers": "static-1.6177",
  "ts-schema": "static-1.2991",
  "framework-builder-read-service-client": "static-1.2911",
  "hub-http-shared-msw-handlers": "static-1.6847",
  "multi-currency-client-types": "static-1.2671",
  "customer-data-associations": "static-1.5829",
  "react-virtualized-auto-sizer": "static-1.24",
  "react-window": "static-1.13",
  "task-forms-lib": "static-1.35279",
  "universal-associations-select": "static-1.9404",
  "fast-json-stable-stringify": "static-1.4",
  "csstype": "static-1.38",
  "jasmine": "static-4.2972",
  "usage-tracker-public": "static-1.5899",
  "content-assistance-lib": "static-1.6085",
  "crm-record-access-management-lib": "static-1.20538",
  "customer-data-content": "static-1.24176",
  "draft-content-plugins": "static-1.23803",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "enrichment-properties-lib": "static-1.9017",
  "FireAlarmUi": "static-1.3491",
  "flux-actions": "static-1.266",
  "marketing-contacts-client": "static-1.6268",
  "pipeline-governance-client-types": "static-1.3023",
  "prospecting-agent-lib": "static-1.6264",
  "react-virtualized": "static-2.73",
  "subscriptions-client": "static-1.40991",
  "surveymonkey-crm-card": "static-1.34936",
  "autolinker": "static-3.11",
  "conditional-properties-service-client": "static-1.2775",
  "google-libphonenumber": "static-1.11",
  "calling-error-reporting": "static-1.29825",
  "card-subscription-highlight-lib": "static-1.32949",
  "invoices-highlight-card-lib": "static-1.48936",
  "orders-highlight-card-lib": "static-1.16650",
  "project-storage": "static-1.3324",
  "quotes-highlight-card-lib": "static-1.64811",
  "crm-export-dialog": "static-1.4927",
  "customer-data-filters": "static-1.46925",
  "FormUrlGenerator": "static-2.3336",
  "testing-library": "static-1.120",
  "academy-common-lib": "static-1.9188",
  "bend-plugin-foundations-components": "static-1-gcm-text-color-inherit.6",
  "floating-ui": "static-1.28",
  "framer-motion": "static-1.40",
  "react-aria": "static-1.38",
  "tanstack-table": "static-1.23",
  "ui-fonts": "static-1.331",
  "bend-plugin-foundations-theming": "static-1.1417",
  "foundations-theming-base": "static-1.1919",
  "growth-onboarding-feedback-components": "static-1.5082",
  "commerce-analytics-service-client": "static-1.2402",
  "hs-test-utils-bend-plugin": "static-1.1738",
  "i18n-data": "static-1.196",
  "moment-timezone": "static-5.51",
  "marketplace-ui-details": "static-1.3366",
  "navigation-components": "static-1.13529",
  "ui-shepherd-tracker": "static-1.6051",
  "property-description-translator": "static-1.2467",
  "quartz-core-utils": "static-1.2242",
  "call-summary": "static-1.31490",
  "reporting-client-types": "static-1.1767",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9090",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "conversations-async-data": "static-2.6295",
  "conversations-error-reporting": "static-1.7575",
  "conversations-http": "static-1.3417",
  "conversations-internal-schema": "static-1.11273",
  "conversations-message-history": "static-1.9711",
  "routing-ui": "static-1.15300",
  "hubs-service-types": "static-1.68",
  "salesImages": "static-1.498",
  "trials-service-types": "static-1.2697",
  "react-flip-move": "static-1.46",
  "feature-store-service-types": "static-1.3289",
  "growth-monetization-service-types": "static-1.3296",
  "upgrade-management-service-types": "static-1.3280",
  "hub-http-janus": "static-1.635",
  "subscription-experience-data-types": "static-1.10047",
  "getting-started-shared-tasks-store": "static-1.10636",
  "final-form": "static-1.39",
  "fintech-outages-service-client-types": "static-1.11706",
  "transactions-exp-service-client-types": "static-1.11702",
  "conversations-skeleton-state": "static-1.6018",
  "integrations-lib": "static-1.9843",
  "chatspot-client-types": "static-1.8340",
  "chatspot-core": "static-1.14845",
  "ContentUtils": "static-1.62590",
  "sassPrefix": "static-1.129",
  "report-customization-components": "static-1.8223",
  "reporting-snowflake": "static-1.49589",
  "activity-history-lib": "static-1.1354",
  "assisted-buying-components": "static-1.5622",
  "bet-customer-success-shared-ui": "static-1.11667",
  "company-details-components": "static-1.4519",
  "company-details-service-types": "static-1.2550",
  "flywheel-recent-conversions-lib": "static-1.1024",
  "industries-core": "static-1.5382",
  "payment-method-components": "static-1.5165",
  "quote-checkout-common-lib": "static-1.8942",
  "quote-checkout-service-types": "static-1.2242",
  "calling-client-interface": "static-1.69337",
  "calling-cross-tab-library": "static-1.17784",
  "calling-integration-cross-tab": "static-1.16824",
  "calling-lifecycle-messages": "static-1.50475",
  "calling-lifecycle-usage-tracker": "static-1.4677",
  "calling-usage-tracker": "static-1.5127",
  "conversations-prop-types": "static-1.6056",
  "shared-worker-versioning": "static-1.9692",
  "hubspot-prosemirror-plugins": "static-1.13068",
  "redux-actions": "static-3.7",
  "share-transcript-modal": "static-1.51503",
  "twilio-voice-sdk": "static-1.50",
  "worker-connection-library": "static-1.11119",
  "domain-review-history-lib": "static-1.1433",
  "flywheel-reject-ql-lib": "static-1.1045",
  "SafeStorage": "static-1.3027",
  "ui-partner-confirmation-links-components": "static-1.21214",
  "FileManagerCore": "static-1.33281",
  "crm-activity-creator-data": "static-1.40609",
  "multi-account-crm-panel-lib": "static-1.11555",
  "sequences-crm-lib": "static-1.22539",
  "quotes-modal-lib": "static-1.95479",
  "call-timeline-event": "static-1.50102",
  "crm-events": "static-1.54772",
  "crm-meetings-components-lib": "static-1.20942",
  "svh-tickets-lib": "static-1.13095",
  "composer-data": "static-1.25022",
  "conversations-inbox-message-history": "static-1.29196",
  "conversations-infrastructure": "static-1.7545",
  "conversations-internal-pub-sub": "static-1.14633",
  "conversations-platform": "static-1.3117",
  "conversations-thread-data": "static-1.62180",
  "crm-events-viz-core": "static-1.27929",
  "hubspotter-http": "static-1.3421",
  "react-transition-group": "static-1.7",
  "ui-addon-conversations-settings": "static-2.27013",
  "ui-suspension-banners-lib": "static-1.5036",
  "zorse-crm-components-lib": "static-1.5634",
  "crm-activity-creator-interactions": "static-1.39334",
  "framework-scoring-history-panel-lib": "static-1.9805",
  "MeetingsLib": "static-2.52885",
  "hub-http-contrib": "static-1.1803",
  "task-queues": "static-1.28065",
  "ui-addon-video-player": "static-1.7398",
  "card-past-feedback-lib": "static-1.36099",
  "location-customization-utils-lib": "static-1.3432",
  "all-properties-panel-lib": "static-1.2074",
  "crm-events-viz-timeline": "static-1.35593",
  "customer-data-modals": "static-1.3393",
  "merge-modal-lib": "static-1.6163",
  "predictive-scores-panel": "static-1.24114",
  "property-history-panel": "static-1.18883",
  "crm-source-interpretation-lib": "static-1.3889",
  "partner-shared-messages-lib": "static-1.12659",
  "ql-visibility-lib": "static-1.3967",
  "redux-mock-store": "static-1.8",
  "automation-platform-service-types": "static-1.2056",
  "guided-selling-core": "static-1.4407",
  "sales-execution-components": "static-1.7545",
  "credit-memos-highlight-card-lib": "static-1.4942",
  "breeze-intelligence-kit": "static-1.3835",
  "policy-lib": "static-1.5423",
  "ui-coaching-tips": "static-1.21930",
  "ui-coaching-tips-shared-config": "static-1.21915",
  "analytics_js": "static-1.3170",
  "blueimp-md5": "static-1.8",
  "calling-cross-tab-messaging": "static-1.17782",
  "feedback-schema": "static-1.47911",
  "forms-utils-lib": "static-1.9955",
  "FormsCommonComponents": "static-1.80362",
  "integrations-tracking-lib": "static-1.4097",
  "MeetingsBase": "static-1.54477",
  "outpost": "static-1.2961",
  "partner-poi-timeline-event": "static-1.34270",
  "qualified-leads-embedded-lib": "static-1.41870",
  "quotes-crm-events-lib": "static-1.36899",
  "react-table": "static-1.15",
  "sales-clients-common": "static-1.45092",
  "sequences-client-types-lib": "static-1.5511",
  "sequences-crm-events-lib": "static-1.22343",
  "settings-ui-nav": "static-2.8667",
  "social-components-lib": "static-1.28355",
  "ui-addon-sales-email": "static-1.3824",
  "ui-tour-react": "static-1.10585",
  "urlinator": "static-1.3167",
  "outreach-assistant-email-generation": "static-1.2394",
  "quotes-client-types": "static-1.30890",
  "sales-email-signature-service-client": "static-1.2627",
  "customer-data-filters-ui-msw-helpers": "static-1.15543",
  "signup-ui-lego-core": "static-1.17874",
  "viral-links-lib": "static-1.5486",
  "media-bridge-lib": "static-1.16427",
  "video-data-lib": "static-1.28793",
  "FileManagerImages": "static-1.30932",
  "trellis-story-utils": "static-1.3178",
  "knowledge-content-types": "static-1.7617",
  "ui-addon-emoji-picker": "static-1.8548",
  "in-meeting-experience-client-types": "static-1.13125",
  "content-embed-lib": "static-1.5977",
  "crm-record-cards-service-types": "static-1.2641",
  "remote-ui": "static-1.39",
  "ui-extensions": "static-1.14361",
  "ui-extensions-remote-renderer": "static-1.11954",
  "universal-page-editor-lib": "static-1.1559",
  "developer-experience-shared-components": "static-1.8703",
  "immutable-less": "static-1.3183",
  "ui-extensibility-client-types": "static-1.2820",
  "markdown-it": "static-1.6",
  "hubspotter-http-shared-msw-handlers": "static-1.6845",
  "platform-navigation-bootstrap": "static-1.11023",
  "dashboard-lib": "static-1.75073",
  "share-with-third-party-component-lib": "static-1.7274",
  "data-quality-ui-library": "static-1.7407",
  "html-to-image": "static-1.29",
  "reporting-plugins": "static-1.6405",
  "reporting-reports": "static-1.60652",
  "data-token-picker": "static-1.13816",
  "navigation-messaging": "static-1.2856",
  "attribution-lib": "static-1.36970",
  "campaigns-build-lib": "static-1.6974",
  "marketing-platform-lib": "static-1.5285",
  "growth-onboarding-reliability": "static-1.3771",
  "sales-checkout-service-client": "static-1.2414",
  "amplitude-session-replay-browser": "static-1.6",
  "stripe-embedded-components": "static-1.4950",
  "idb-keyval": "static-1.20",
  "simple-logging-lib": "static-1.1666",
  "integrations-error-boundary-lib": "static-1.7258",
  "ai-settings-ui-library": "static-1.5675",
  "automation-enrollment-service-types": "static-1.2550",
  "crm-cards-test-utils": "static-1.37249",
  "renewal-center-service-types": "static-1.2802",
  "submissions-lib": "static-1.40863",
  "ui-forms-components": "static-1.7950",
  "portal-details-components": "static-1.13361",
  "ui-extensions-plugin-flywheel": "static-1.8895",
  "ui-product-approvals": "static-1.23398",
  "customer-success-client-types": "static-1.14073",
  "sales-enablement-lib": "static-1.11188",
  "sales-leader-insights-components-lib": "static-1.12892",
  "guided-actions-lib": "static-1.14046",
  "framework-scoring-client-types": "static-1.10858",
  "fsm": "static-1.2322",
  "card-bet-associated-companies-lib": "static-1.71081",
  "card-bet-deal-support-requests-lib": "static-1.61822",
  "card-bet-quotes-lib": "static-1.71088",
  "card-deal-splits-lib": "static-1.38361",
  "card-flywheel-ql-summary-lib": "static-1.39968",
  "card-flywheel-recent-conversions-lib": "static-1.39969",
  "card-invoices-lib": "static-1.50460",
  "card-marketing-event-about-lib": "static-1.50242",
  "card-marketing-event-activity-lib": "static-1.50241",
  "card-prospecting-notes": "static-1.32259",
  "card-qualified-leads-lib": "static-1.71243",
  "card-sfdcsync-lib": "static-1.50312",
  "card-workflows-lib": "static-1.67258",
  "integrations-sync-card-ui": "static-1.21287",
  "partner-poi-crm-card": "static-1.13714",
  "recording-preview-card": "static-1.11135",
  "ui-sales-order-wizard-card": "static-1.26271",
  "predictive-scores-lib-components": "static-1.22509",
  "process-guide-chirp": "static-1.3200",
  "gapi-client-types": "static-1.3",
  "google-picker-types": "static-1.3",
  "ui-google-drive-picker": "static-1.730",
  "deep-diff": "static-1.5",
  "academy-service-client": "static-1.2688",
  "zustand": "static-1.45",
  "marketplace-ui-reviews": "static-1.13425",
  "marketplace-ui-tracking": "static-1.7640",
  "cms-field-types": "static-1.3403",
  "content-icons-ui": "static-1.1863",
  "reporting-datasets-permissions-lib": "static-1.6725",
  "fintech-buying-service-clients": "static-1.2357",
  "account-and-billing-contacts-usage": "static-2.17552",
  "emoji-regex": "static-1.7",
  "signup-ui-full-screen-search": "static-1.9997",
  "billing-payments-client-types": "static-1.2704",
  "buying-experience-components": "static-1.8427",
  "checkout-service-types": "static-1.2792",
  "growth-pro-utils-lib": "static-1.7704",
  "audio-components": "static-1.4236",
  "video-components": "static-1.7145",
  "video-embed": "static-1.29634",
  "conversations-calling-message": "static-1.53878",
  "crm-events-viz-test-utils": "static-1.16550",
  "crm-pipeline-events-ui": "static-1.21909",
  "conversations-routing-lib": "static-1.5603",
  "conversations-visibility-tools": "static-1.4386",
  "data-ops-fullstory": "static-1.3948",
  "re-reselect": "static-1.4",
  "signup-ui-url-generator": "static-2.6672",
  "usage-tracker-anonymous": "static-1.4505",
  "usage-tracker-multi": "static-1.4502",
  "automation-ui-core": "static-2.15296",
  "automation-ui-permissions": "static-1.13658",
  "workspace-components": "static-1.2608",
  "settings-content-modals": "static-1.39225",
  "forms-ai-lib": "static-1.2034",
  "react-tinymce": "static-1.49962",
  "SharedLegalStrings": "static-1.1292",
  "tinymce-config": "static-2.49088",
  "meetings-client-types": "static-1.2680",
  "messaging-types-lib": "static-1.39693",
  "apps-service-types": "static-1.2816",
  "oauth-service-types": "static-1.2926",
  "platform-infra-nav-components": "static-1.6540",
  "campaign-roi-lib": "static-1.2138",
  "stripe-connect-js": "static-1.37",
  "customer-data-sidebar-test-utils": "static-1.34959",
  "form-builder-ui": "static-1.7724",
  "user-configuration-lib": "static-1.23956",
  "ui-deal-management-components-lib": "static-1.15170",
  "ui-signature-editor": "static-1.13238",
  "immerable": "static-1.2790",
  "social-insights-client-types": "static-1.17259",
  "automation-ui-routing": "static-1.14720",
  "automation-ui-source-apps": "static-1.12442",
  "ui-addon-draggable-compat": "static-2.2887",
  "access-control-lib": "static-1.9094",
  "EmailComponents": "static-1.48369",
  "EmailData": "static-1.47045",
  "redux-less": "static-2.8056",
  "tinymce-themes": "static-1.51058",
  "interframe": "static-3.3422",
  "tinymce-data": "static-1.35173",
  "tinymce-plugins": "static-1.52202",
  "ContentData": "static-1.62666",
  "marketing-email-service-types": "static-1.1408",
  "layout-dnd-components": "static-1.10560",
  "layout-dnd-utils": "static-1.9535",
  "app-users-service-client": "static-1.3657",
  "app-users-service-types": "static-1.3063",
  "framework-listing-lib": "static-2.21704",
  "mini-checkout-client": "static-1.23835",
  "onboarding-utils": "static-1.3968",
  "ContentComponents": "static-2.65547",
  "messaging-editing-lib": "static-1.39957",
  "ui-tool-access": "static-1.8670",
  "automation-ui-types": "static-1.13360",
  "NamespacedHubStyle": "static-2.8083",
  "codemirror": "static-5.69",
  "react-codemirror": "static-1.9224",
  "layout-data-lib": "static-1.7860",
  "framework-listing-lib-shared-msw-handlers": "static-1.6738",
  "touchless-buying-components": "static-1.3069",
  "merchandise-lib": "static-1.221",
  "data-token-views": "static-1.13797",
  "simple-menus-core": "static-1.13333",
  "simple-menus-lib": "static-1.14851",
  "ui-memberships-settings-lib": "static-1.27656",
  "videoconference-integration-components": "static-1.4737",
  "automation-applications-service-types": "static-1.2462",
  "ContentEditorUI": "static-2.70990",
  "short-messages-app-service-client": "static-1.2791",
  "web-interactives-components": "static-1.11238",
  "web-interactives-data": "static-1.11239",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "checkout-sdk": "static-3.20678",
  "upgrade-catalog-service-types": "static-1.2544",
  "seamless-immutable": "static-7.6",
  "backbone": "static-1.6",
  "content-management-data-lib": "static-1.3676",
  "copilot-plugins": "static-1.5576",
  "cta-picker": "static-1.30704",
  "editor-components": "static-1.11642",
  "editor-iframe-lib": "static-1.6921",
  "error-messaging-js": "static-1.3913",
  "pictos": "static-7.158",
  "redux-request-state": "static-1.9199",
  "smart-content-core": "static-1.36658",
  "smart-content-lib": "static-1.37311",
  "social-composer-lib": "static-1.52772",
  "structured-content-lib": "static-1.19586",
  "theme-previewer-lib": "static-1.47229",
  "tinymce-copilot": "static-1.11156",
  "ui-active-theme-content-creator-lib": "static-1.31143",
  "xray-recommendation-lib": "static-1.5699",
  "hub-http-rxjs": "static-1.602",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "jquery": "static-3.6",
  "ai-rendering-library": "static-1.4438",
  "ui-brand-identity-lib": "static-1.7823",
  "fuzzy": "static-1.8",
  "codemirror-dlb": "static-1.52544",
  "redux-undo": "static-1.10",
  "highlight.js": "static-1.45"
},
  depPathPrefixes: {
  "crm-index-ui": "/crm-index-ui/static-2.46503",
  "ably-hubspot-js": "/ably-hubspot-js/static-1.435",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.3048",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.29616",
  "card-associated-objects-lib": "/card-associated-objects-lib/static-1.38105",
  "card-associated-objects-lib-legacy": "/card-associated-objects-lib-legacy/static-1.5736",
  "client-types": "/client-types/static-1.370",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.5396",
  "commerce-products-lib": "/commerce-products-lib/static-1.4257",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14256",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.6002",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3145",
  "contextual-settings-lib": "/contextual-settings-lib/static-1.1522",
  "credit-memos-ui-lib": "/credit-memos-ui-lib/static-1.5587",
  "crm_data": "/crm_data/static-4.86185",
  "crm-cards-global-registry": "/crm-cards-global-registry/static-1.14099",
  "crm-common-dlb": "/crm-common-dlb/static-1.3941",
  "crm-component-utils": "/crm-component-utils/static-1.33944",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.4996",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.2523",
  "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22429",
  "crm-legacy-links": "/crm-legacy-links/static-1.71071",
  "crm-message-bus": "/crm-message-bus/static-1.35918",
  "crm-object-board-core": "/crm-object-board-core/static-1.12106",
  "crm-object-gantt": "/crm-object-gantt/static-1.2085",
  "crm-object-map": "/crm-object-map/static-1.1543",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.5908",
  "crm-object-search-query-utilities-test-utils": "/crm-object-search-query-utilities-test-utils/static-1.5570",
  "crm-pipeline-board-settings-lib": "/crm-pipeline-board-settings-lib/static-1.25156",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.2973",
  "customer-data-bulk-actions": "/customer-data-bulk-actions/static-1.29405",
  "customer-data-objects": "/customer-data-objects/static-1.6217",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11508",
  "customer-data-properties": "/customer-data-properties/static-1.45010",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.40281",
  "customer-data-views-management": "/customer-data-views-management/static-1.21806",
  "data-fetching-client": "/data-fetching-client/static-1.8233",
  "data-privacy-hub-settings-service-types": "/data-privacy-hub-settings-service-types/static-1.2836",
  "demographics-client": "/demographics-client/static-1.4042",
  "dispatcher": "/dispatcher/static-1.111",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.9728",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.293",
  "external-options-client-types": "/external-options-client-types/static-1.2939",
  "feedback-loader": "/feedback-loader/static-1.26244",
  "foundations-components": "/foundations-components/static-1-gcm-text-color-inherit.6",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-gcm-text-color-inherit.6",
  "foundations-theming": "/foundations-theming/static-1.2934",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.651",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5386",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5481",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.6933",
  "framework-data-table": "/framework-data-table/static-2.8248",
  "general-store": "/general-store/static-6.20",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.2280",
  "growth-payments-core": "/growth-payments-core/static-1.20584",
  "head-dlb": "/head-dlb/static-1.3679",
  "highcharts": "/highcharts/static-8.80",
  "history": "/history/static-4.47",
  "hs-promise-utils": "/hs-promise-utils/static-1.4136",
  "hs-test-utils": "/hs-test-utils/static-1.6627",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3448",
  "hubspot-dlb": "/hubspot-dlb/static-2.1317",
  "HubStyleTokens": "/HubStyleTokens/static-2.10112",
  "I18n": "/I18n/static-7.1372",
  "immer": "/immer/static-1.33",
  "immutable": "/immutable/static-2.19",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2626",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2797",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3062",
  "jasmine-immutable": "/jasmine-immutable/static-1.1581",
  "jasmine-runner": "/jasmine-runner/static-1.5022",
  "laboratory-lib": "/laboratory-lib/static-3.5880",
  "lodash": "/lodash/static-1.3",
  "marketing-event-attendance-cards-ui": "/marketing-event-attendance-cards-ui/static-1.4590",
  "marketplace-embed": "/marketplace-embed/static-1.15702",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.10872",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.41204",
  "onboarding-scopes": "/onboarding-scopes/static-1.5165",
  "onboarding-tours": "/onboarding-tours/static-1.13933",
  "payments-zero-states-lib": "/payments-zero-states-lib/static-1.14011",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2727",
  "PortalIdParser": "/PortalIdParser/static-2.272",
  "products-iframe-lib": "/products-iframe-lib/static-1.2287",
  "products-ui-components": "/products-ui-components/static-1.34777",
  "property-management-iframe": "/property-management-iframe/static-1.7778",
  "quartz": "/quartz/static-1.5375",
  "quick-fetch": "/quick-fetch/static-1.2832",
  "raven": "/raven/static-3.4440",
  "react": "/react/static-7.151",
  "react-dlb": "/react-dlb/static-1.51",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15223",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-utils": "/react-utils/static-2.4180",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.25785",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6578",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.6993",
  "reporting-data": "/reporting-data/static-1.60967",
  "reporting-dlb": "/reporting-dlb/static-1.53885",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.2902",
  "reporting-visualizations": "/reporting-visualizations/static-1.53045",
  "sales-views-client-types": "/sales-views-client-types/static-1.2970",
  "self-service-api": "/self-service-api/static-1.8814",
  "settings-ui-lib": "/settings-ui-lib/static-1.11185",
  "signup-constants": "/signup-constants/static-1.15864",
  "styled-components": "/styled-components/static-2.40",
  "superstore": "/superstore/static-1.3405",
  "svh-onboarding-config-shared-lib": "/svh-onboarding-config-shared-lib/static-1.2012",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.29",
  "trial-components-library": "/trial-components-library/static-1.10613",
  "ui-addon-draggable": "/ui-addon-draggable/static-2.1196",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6610",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15772",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4252",
  "UIComponents": "/UIComponents/static-3.7061",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.3003",
  "usage-tracker-core": "/usage-tracker-core/static-1.5938",
  "user-context": "/user-context/static-1.3779",
  "webpack-env": "/webpack-env/static-1.54",
  "wootric-nps": "/wootric-nps/static-1.5580",
  "account-and-billing-components": "/account-and-billing-components/static-1.16094",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.14844",
  "accounting-extension-card-ui": "/accounting-extension-card-ui/static-1.30798",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.4586",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.4991",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3411",
  "attribution-sidebar-cards": "/attribution-sidebar-cards/static-1.38583",
  "BizOpsCrmUIComponents": "/BizOpsCrmUIComponents/static-1.39929",
  "call-widget-addon": "/call-widget-addon/static-2.26906",
  "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.25050",
  "calling-integration-timeline-event": "/calling-integration-timeline-event/static-1.12750",
  "calling-internal-common": "/calling-internal-common/static-1.29819",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.58179",
  "calling-ui-library": "/calling-ui-library/static-1.64098",
  "card-biz-ops-customer-success-lib": "/card-biz-ops-customer-success-lib/static-1.71102",
  "card-biz-ops-domain-controls-lib": "/card-biz-ops-domain-controls-lib/static-1.71103",
  "card-biz-ops-related-contacts-lib": "/card-biz-ops-related-contacts-lib/static-1.71102",
  "card-crm-attribution-lib": "/card-crm-attribution-lib/static-1.49375",
  "card-deal-collaborators-lib": "/card-deal-collaborators-lib/static-1.32181",
  "card-deal-shared-view-lib": "/card-deal-shared-view-lib/static-1.63017",
  "card-engagement-attachments-lib": "/card-engagement-attachments-lib/static-1.67357",
  "card-gdpr-subscriptions-card-lib": "/card-gdpr-subscriptions-card-lib/static-1.41453",
  "card-integration-card-lib": "/card-integration-card-lib/static-1.67418",
  "card-linked-in-sales-navigator-lib": "/card-linked-in-sales-navigator-lib/static-1.35037",
  "card-lists-lib": "/card-lists-lib/static-1.65576",
  "card-past-conversations-lib": "/card-past-conversations-lib/static-1.31981",
  "card-payment-history-lib": "/card-payment-history-lib/static-1.30969",
  "card-playbooks-lib": "/card-playbooks-lib/static-1.57643",
  "card-preview-highlight-lib": "/card-preview-highlight-lib/static-1.69622",
  "card-profile-products-lib": "/card-profile-products-lib/static-1.51129",
  "card-profile-quotes-lib": "/card-profile-quotes-lib/static-1.78330",
  "card-properties-lib": "/card-properties-lib/static-1.38144",
  "card-sales-activities-timeline": "/card-sales-activities-timeline/static-1.32259",
  "card-target-account-lib": "/card-target-account-lib/static-1.67068",
  "card-website-activity-lib": "/card-website-activity-lib/static-1.67883",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.14839",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.51614",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.14142",
  "commerce-subscription-cards-lib": "/commerce-subscription-cards-lib/static-1.25351",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.30526",
  "composer-plugins": "/composer-plugins/static-1.66149",
  "conversations-thread-view-crm-events": "/conversations-thread-view-crm-events/static-1.28844",
  "copilot-toolkit": "/copilot-toolkit/static-1.5603",
  "credit-memos-iframe-lib": "/credit-memos-iframe-lib/static-1.5589",
  "crm_components": "/crm_components/static-3.86185",
  "crm_schema": "/crm_schema/static-3.86222",
  "crm_ui": "/crm_ui/static-5.86143",
  "crm_universal": "/crm_universal/static-1.20356",
  "crm-activity-creator-interaction-window": "/crm-activity-creator-interaction-window/static-1.40062",
  "crm-activity-creator-interactions-legacy": "/crm-activity-creator-interactions-legacy/static-1.30531",
  "crm-activity-creator-widgets": "/crm-activity-creator-widgets/static-1.46113",
  "crm-associations-table": "/crm-associations-table/static-1.35793",
  "crm-cards": "/crm-cards/static-1.38699",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.37402",
  "crm-command-handler": "/crm-command-handler/static-1.29986",
  "crm-display-components": "/crm-display-components/static-1.19694",
  "crm-events-components": "/crm-events-components/static-1.54765",
  "crm-events-data": "/crm-events-data/static-1.54778",
  "crm-fe-perf": "/crm-fe-perf/static-1.21609",
  "crm-index-ui-toolbar": "/crm-index-ui-toolbar/static-1.1752",
  "crm-index-view-table-edit-columns-modal": "/crm-index-view-table-edit-columns-modal/static-1.15483",
  "crm-index-visualization-toolbar": "/crm-index-visualization-toolbar/static-1.2177",
  "crm-index-visualization-toolbar-test-utils": "/crm-index-visualization-toolbar-test-utils/static-1.1548",
  "crm-links": "/crm-links/static-1.4744",
  "crm-object-board": "/crm-object-board/static-1.22027",
  "crm-object-board-card": "/crm-object-board-card/static-1.12102",
  "crm-object-preview": "/crm-object-preview/static-1.20746",
  "crm-object-table": "/crm-object-table/static-1.16909",
  "crm-timeline": "/crm-timeline/static-1.83105",
  "crm-timeline-tasks": "/crm-timeline-tasks/static-1.32099",
  "cropperjs": "/cropperjs/static-1.10",
  "cssUtils": "/cssUtils/static-1.459",
  "customer-data-board": "/customer-data-board/static-1.19162",
  "customer-data-board-card": "/customer-data-board-card/static-1.19123",
  "customer-data-bulk-actions-container": "/customer-data-bulk-actions-container/static-1.15116",
  "customer-data-communicator": "/customer-data-communicator/static-1.39552",
  "customer-data-email": "/customer-data-email/static-1.15526",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.33110",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6544",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11606",
  "customer-data-rte": "/customer-data-rte/static-1.28481",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8359",
  "deal-registration-ui": "/deal-registration-ui/static-1.29550",
  "deal-splits-cards-ui": "/deal-splits-cards-ui/static-1.38975",
  "deal-splits-sidebar": "/deal-splits-sidebar/static-1.38881",
  "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.19728",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.18989",
  "draft-signature-plugin": "/draft-signature-plugin/static-1.19476",
  "email-confirm-ui": "/email-confirm-ui/static-2.4262",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.20073",
  "ExportDialog": "/ExportDialog/static-6.9022",
  "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.526",
  "file-manager-components": "/file-manager-components/static-1.17781",
  "FileManagerLib": "/FileManagerLib/static-1.33422",
  "flywheel-feedback-panel-components": "/flywheel-feedback-panel-components/static-1.5901",
  "foundations-assets": "/foundations-assets/static-1.3540",
  "framework-app-settings-features-lib": "/framework-app-settings-features-lib/static-1.3670",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6500",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11518",
  "graphql": "/graphql/static-1.58",
  "growth-data-modal": "/growth-data-modal/static-1.3822",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4130",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.4349",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3796",
  "HeadJS": "/HeadJS/static-2.563",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13076",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.2969",
  "HubStyle": "/HubStyle/static-2.10421",
  "icons": "/icons/static-2.591",
  "in-meeting-experience-ui-components": "/in-meeting-experience-ui-components/static-1.16425",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.9282",
  "integration-settings-components": "/integration-settings-components/static-1.10081",
  "integrations-directory-panel-lib": "/integrations-directory-panel-lib/static-1.7449",
  "invoices-card-lib": "/invoices-card-lib/static-1.51080",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.51009",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.48951",
  "lead-tracking-lib": "/lead-tracking-lib/static-1.33227",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.7757",
  "marketing-contacts-ui": "/marketing-contacts-ui/static-1.6267",
  "marketing-event-cards-ui": "/marketing-event-cards-ui/static-1.31216",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12002",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13466",
  "metrics-js": "/metrics-js/static-1.8343",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.334",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6450",
  "nav-meta": "/nav-meta/static-1.25166",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.5598",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3134",
  "orders-card-lib": "/orders-card-lib/static-1.16367",
  "panel-deal-registration-ai-summary-lib": "/panel-deal-registration-ai-summary-lib/static-1.21953",
  "partner-shared-view-ui": "/partner-shared-view-ui/static-1.41863",
  "playbooks-modal": "/playbooks-modal/static-1.74816",
  "playlists-lib": "/playlists-lib/static-1.6409",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.12542",
  "property-translator": "/property-translator/static-1.4003",
  "quartz-core": "/quartz-core/static-1.4594",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.73522",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.8853",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "react-select-plus": "/react-select-plus/static-1.65",
  "recent-activities-card": "/recent-activities-card/static-1.52629",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reference-resolvers": "/reference-resolvers/static-1.6774",
  "reporting-action-components": "/reporting-action-components/static-1.35552",
  "reporting-crm-object-table": "/reporting-crm-object-table/static-1.2136",
  "reporting-enablement": "/reporting-enablement/static-1.16328",
  "reporting-ui-components": "/reporting-ui-components/static-2.58246",
  "reselect": "/reselect/static-2.16",
  "rich-text-lib": "/rich-text-lib/static-1.17161",
  "rpc-client-utils": "/rpc-client-utils/static-1.3352",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6838",
  "salesforce-sync-card-ui": "/salesforce-sync-card-ui/static-1.7566",
  "sanitize-text": "/sanitize-text/static-1.6813",
  "sequences-lib": "/sequences-lib/static-1.5655",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "subscriptions-components": "/subscriptions-components/static-1.40751",
  "svh-conversations-settings-lib": "/svh-conversations-settings-lib/static-1.2012",
  "tasks-lib": "/tasks-lib/static-1.32173",
  "timezone-utils": "/timezone-utils/static-2.3887",
  "transcript-sidebar": "/transcript-sidebar/static-1.61858",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.4315",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8059",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9650",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9537",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7521",
  "ui-addon-opt": "/ui-addon-opt/static-4.7281",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8238",
  "ui-addon-scriptloader": "/ui-addon-scriptloader/static-1.11003",
  "ui-addon-teams": "/ui-addon-teams/static-1.19513",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8822",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7499",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8879",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8670",
  "ui-universal-auth": "/ui-universal-auth/static-1.7420",
  "usage-tracker": "/usage-tracker/static-1.6088",
  "usage-tracker-container": "/usage-tracker-container/static-1.6078",
  "atom": "/atom/static-1.3865",
  "hs-lodash": "/hs-lodash/static-4.45",
  "planout": "/planout/static-5.12",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "sanitize": "/sanitize/static-1.2997",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
  "raven-hubspot": "/raven-hubspot/static-1.4747",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2294",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1652",
  "quartz-webpack": "/quartz-webpack/static-1.1599",
  "ably": "/ably/static-1.18",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.29841",
  "avatar-components": "/avatar-components/static-1.1032",
  "calling-global-api": "/calling-global-api/static-1.56797",
  "campaigns-lib": "/campaigns-lib/static-1.21552",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.31104",
  "customer-data-tracking": "/customer-data-tracking/static-1.5432",
  "payment-link-components": "/payment-link-components/static-1.17905",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.8974",
  "persist-promise": "/persist-promise/static-1.2368",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
  "utility-belt": "/utility-belt/static-1.1201",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7232",
  "hs-story-utils": "/hs-story-utils/static-1.8015",
  "msw": "/msw/static-1.39",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17073",
  "StyleGuideUI": "/StyleGuideUI/static-3.453",
  "ui-images": "/ui-images/static-2.805",
  "cv-backend-services": "/cv-backend-services/static-1.1110",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1729",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3710",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.43",
  "react-dnd-compat": "/react-dnd-compat/static-1.3269",
  "magpie-lib": "/magpie-lib/static-1.4304",
  "magpie-types": "/magpie-types/static-1.3764",
  "adobe-sign-cards-lib": "/adobe-sign-cards-lib/static-1.12481",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4203",
  "automation-ui-crm-card-workflows-invoker": "/automation-ui-crm-card-workflows-invoker/static-1.4583",
  "buyer-intent-card": "/buyer-intent-card/static-1.15637",
  "card-call-summaries-lib": "/card-call-summaries-lib/static-1.29682",
  "card-company-summary-lib": "/card-company-summary-lib/static-1.13292",
  "card-customer-spend-trends-lib": "/card-customer-spend-trends-lib/static-1.20571",
  "card-flywheel-activity-history-lib": "/card-flywheel-activity-history-lib/static-1.1780",
  "card-flywheel-company-overview-lib": "/card-flywheel-company-overview-lib/static-1.10809",
  "card-flywheel-domain-review-history-lib": "/card-flywheel-domain-review-history-lib/static-1.437",
  "card-flywheel-high-intent-associated-contacts-lib": "/card-flywheel-high-intent-associated-contacts-lib/static-1.10809",
  "card-guest-access-management-lib": "/card-guest-access-management-lib/static-1.2396",
  "card-guided-execution-activities": "/card-guided-execution-activities/static-1.3780",
  "card-knowledge-base-lib": "/card-knowledge-base-lib/static-1.6712",
  "card-lead-insights": "/card-lead-insights/static-1.8947",
  "card-lead-qualification-lib": "/card-lead-qualification-lib/static-1.24565",
  "card-object-highlight-lib": "/card-object-highlight-lib/static-1.1083",
  "card-object-summary-lib": "/card-object-summary-lib/static-1.2742",
  "card-other-tickets-lib": "/card-other-tickets-lib/static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "/card-partner-client-portal-usage-outcomes-lib/static-1.25396",
  "card-partner-client-unified-usage-score-lib": "/card-partner-client-unified-usage-score-lib/static-1.19761",
  "card-prospecting-research-agent": "/card-prospecting-research-agent/static-1.1835",
  "card-tasks-timeline-lib": "/card-tasks-timeline-lib/static-1.9577",
  "card-ticket-summary-lib": "/card-ticket-summary-lib/static-1.11424",
  "crm-actions": "/crm-actions/static-1.4684",
  "crm-associations-pivot": "/crm-associations-pivot/static-1.33923",
  "crm-clv-report": "/crm-clv-report/static-1.2581",
  "crm-data-highlights": "/crm-data-highlights/static-1.36331",
  "crm-events-viz-cards": "/crm-events-viz-cards/static-1.35585",
  "crm-events-viz-totals": "/crm-events-viz-totals/static-1.27138",
  "crm-extension": "/crm-extension/static-1.35651",
  "crm-pipeline-approvals-lib": "/crm-pipeline-approvals-lib/static-1.18605",
  "crm-properties-list": "/crm-properties-list/static-1.32969",
  "crm-property-history": "/crm-property-history/static-1.11029",
  "crm-quick-actions": "/crm-quick-actions/static-1.12479",
  "crm-relative-timeline": "/crm-relative-timeline/static-1.12907",
  "crm-report": "/crm-report/static-1.36538",
  "crm-simple-deadline": "/crm-simple-deadline/static-1.13125",
  "crm-stage-tracker": "/crm-stage-tracker/static-1.31502",
  "crm-statistics": "/crm-statistics/static-1.25547",
  "custom-events-card-lib": "/custom-events-card-lib/static-1.292",
  "customer-overview-card-lib": "/customer-overview-card-lib/static-1.4155",
  "customer-success-contacts-card-lib": "/customer-success-contacts-card-lib/static-1.12261",
  "deal-summary-components": "/deal-summary-components/static-1.15120",
  "docusign-cards-lib": "/docusign-cards-lib/static-1.21988",
  "flywheel-growth-plans-crm-card": "/flywheel-growth-plans-crm-card/static-1.1303",
  "guided-actions-card": "/guided-actions-card/static-1.8816",
  "guided-selling-stage-tracker-card": "/guided-selling-stage-tracker-card/static-1.5942",
  "health-score-card-lib": "/health-score-card-lib/static-1.15544",
  "help-desk-insights-lib-crm-cards": "/help-desk-insights-lib-crm-cards/static-1.17750",
  "intelligence-overview-card": "/intelligence-overview-card/static-1.9469",
  "intelligence-overview-lib": "/intelligence-overview-lib/static-1.7720",
  "invoices-history-card-lib": "/invoices-history-card-lib/static-1.25364",
  "lead-scores-card": "/lead-scores-card/static-1.11924",
  "legacy-sidebar-card-lib": "/legacy-sidebar-card-lib/static-1.29137",
  "payment-schedule-card-lib": "/payment-schedule-card-lib/static-1.22716",
  "playbooks-card": "/playbooks-card/static-1.37526",
  "predictive-scores-card": "/predictive-scores-card/static-1.25112",
  "process-guide-cards": "/process-guide-cards/static-1.3368",
  "products-cards-lib": "/products-cards-lib/static-1.3851",
  "purchase-history-lib": "/purchase-history-lib/static-1.15053",
  "ui-google-drive-attachments": "/ui-google-drive-attachments/static-1.1159",
  "ui-google-drive-insights": "/ui-google-drive-insights/static-1.1161",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6177",
  "ts-schema": "/ts-schema/static-1.2991",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2911",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6847",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2671",
  "customer-data-associations": "/customer-data-associations/static-1.5829",
  "react-virtualized-auto-sizer": "/react-virtualized-auto-sizer/static-1.24",
  "react-window": "/react-window/static-1.13",
  "task-forms-lib": "/task-forms-lib/static-1.35279",
  "universal-associations-select": "/universal-associations-select/static-1.9404",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "csstype": "/csstype/static-1.38",
  "jasmine": "/jasmine/static-4.2972",
  "usage-tracker-public": "/usage-tracker-public/static-1.5899",
  "content-assistance-lib": "/content-assistance-lib/static-1.6085",
  "crm-record-access-management-lib": "/crm-record-access-management-lib/static-1.20538",
  "customer-data-content": "/customer-data-content/static-1.24176",
  "draft-content-plugins": "/draft-content-plugins/static-1.23803",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.9017",
  "FireAlarmUi": "/FireAlarmUi/static-1.3491",
  "flux-actions": "/flux-actions/static-1.266",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.6268",
  "pipeline-governance-client-types": "/pipeline-governance-client-types/static-1.3023",
  "prospecting-agent-lib": "/prospecting-agent-lib/static-1.6264",
  "react-virtualized": "/react-virtualized/static-2.73",
  "subscriptions-client": "/subscriptions-client/static-1.40991",
  "surveymonkey-crm-card": "/surveymonkey-crm-card/static-1.34936",
  "autolinker": "/autolinker/static-3.11",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2775",
  "google-libphonenumber": "/google-libphonenumber/static-1.11",
  "calling-error-reporting": "/calling-error-reporting/static-1.29825",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.32949",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.48936",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.16650",
  "project-storage": "/project-storage/static-1.3324",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.64811",
  "crm-export-dialog": "/crm-export-dialog/static-1.4927",
  "customer-data-filters": "/customer-data-filters/static-1.46925",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3336",
  "testing-library": "/testing-library/static-1.120",
  "academy-common-lib": "/academy-common-lib/static-1.9188",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-gcm-text-color-inherit.6",
  "floating-ui": "/floating-ui/static-1.28",
  "framer-motion": "/framer-motion/static-1.40",
  "react-aria": "/react-aria/static-1.38",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-fonts": "/ui-fonts/static-1.331",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1417",
  "foundations-theming-base": "/foundations-theming-base/static-1.1919",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5082",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2402",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1738",
  "i18n-data": "/i18n-data/static-1.196",
  "moment-timezone": "/moment-timezone/static-5.51",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.3366",
  "navigation-components": "/navigation-components/static-1.13529",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6051",
  "property-description-translator": "/property-description-translator/static-1.2467",
  "quartz-core-utils": "/quartz-core-utils/static-1.2242",
  "call-summary": "/call-summary/static-1.31490",
  "reporting-client-types": "/reporting-client-types/static-1.1767",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9090",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "conversations-async-data": "/conversations-async-data/static-2.6295",
  "conversations-error-reporting": "/conversations-error-reporting/static-1.7575",
  "conversations-http": "/conversations-http/static-1.3417",
  "conversations-internal-schema": "/conversations-internal-schema/static-1.11273",
  "conversations-message-history": "/conversations-message-history/static-1.9711",
  "routing-ui": "/routing-ui/static-1.15300",
  "hubs-service-types": "/hubs-service-types/static-1.68",
  "salesImages": "/salesImages/static-1.498",
  "trials-service-types": "/trials-service-types/static-1.2697",
  "react-flip-move": "/react-flip-move/static-1.46",
  "feature-store-service-types": "/feature-store-service-types/static-1.3289",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3296",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3280",
  "hub-http-janus": "/hub-http-janus/static-1.635",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.10047",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10636",
  "final-form": "/final-form/static-1.39",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.11706",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.11702",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6018",
  "integrations-lib": "/integrations-lib/static-1.9843",
  "chatspot-client-types": "/chatspot-client-types/static-1.8340",
  "chatspot-core": "/chatspot-core/static-1.14845",
  "ContentUtils": "/ContentUtils/static-1.62590",
  "sassPrefix": "/sassPrefix/static-1.129",
  "report-customization-components": "/report-customization-components/static-1.8223",
  "reporting-snowflake": "/reporting-snowflake/static-1.49589",
  "activity-history-lib": "/activity-history-lib/static-1.1354",
  "assisted-buying-components": "/assisted-buying-components/static-1.5622",
  "bet-customer-success-shared-ui": "/bet-customer-success-shared-ui/static-1.11667",
  "company-details-components": "/company-details-components/static-1.4519",
  "company-details-service-types": "/company-details-service-types/static-1.2550",
  "flywheel-recent-conversions-lib": "/flywheel-recent-conversions-lib/static-1.1024",
  "industries-core": "/industries-core/static-1.5382",
  "payment-method-components": "/payment-method-components/static-1.5165",
  "quote-checkout-common-lib": "/quote-checkout-common-lib/static-1.8942",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.2242",
  "calling-client-interface": "/calling-client-interface/static-1.69337",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.17784",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.16824",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.50475",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.4677",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5127",
  "conversations-prop-types": "/conversations-prop-types/static-1.6056",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9692",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.13068",
  "redux-actions": "/redux-actions/static-3.7",
  "share-transcript-modal": "/share-transcript-modal/static-1.51503",
  "twilio-voice-sdk": "/twilio-voice-sdk/static-1.50",
  "worker-connection-library": "/worker-connection-library/static-1.11119",
  "domain-review-history-lib": "/domain-review-history-lib/static-1.1433",
  "flywheel-reject-ql-lib": "/flywheel-reject-ql-lib/static-1.1045",
  "SafeStorage": "/SafeStorage/static-1.3027",
  "ui-partner-confirmation-links-components": "/ui-partner-confirmation-links-components/static-1.21214",
  "FileManagerCore": "/FileManagerCore/static-1.33281",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.40609",
  "multi-account-crm-panel-lib": "/multi-account-crm-panel-lib/static-1.11555",
  "sequences-crm-lib": "/sequences-crm-lib/static-1.22539",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.95479",
  "call-timeline-event": "/call-timeline-event/static-1.50102",
  "crm-events": "/crm-events/static-1.54772",
  "crm-meetings-components-lib": "/crm-meetings-components-lib/static-1.20942",
  "svh-tickets-lib": "/svh-tickets-lib/static-1.13095",
  "composer-data": "/composer-data/static-1.25022",
  "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.29196",
  "conversations-infrastructure": "/conversations-infrastructure/static-1.7545",
  "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14633",
  "conversations-platform": "/conversations-platform/static-1.3117",
  "conversations-thread-data": "/conversations-thread-data/static-1.62180",
  "crm-events-viz-core": "/crm-events-viz-core/static-1.27929",
  "hubspotter-http": "/hubspotter-http/static-1.3421",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-addon-conversations-settings": "/ui-addon-conversations-settings/static-2.27013",
  "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5036",
  "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5634",
  "crm-activity-creator-interactions": "/crm-activity-creator-interactions/static-1.39334",
  "framework-scoring-history-panel-lib": "/framework-scoring-history-panel-lib/static-1.9805",
  "MeetingsLib": "/MeetingsLib/static-2.52885",
  "hub-http-contrib": "/hub-http-contrib/static-1.1803",
  "task-queues": "/task-queues/static-1.28065",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7398",
  "card-past-feedback-lib": "/card-past-feedback-lib/static-1.36099",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.3432",
  "all-properties-panel-lib": "/all-properties-panel-lib/static-1.2074",
  "crm-events-viz-timeline": "/crm-events-viz-timeline/static-1.35593",
  "customer-data-modals": "/customer-data-modals/static-1.3393",
  "merge-modal-lib": "/merge-modal-lib/static-1.6163",
  "predictive-scores-panel": "/predictive-scores-panel/static-1.24114",
  "property-history-panel": "/property-history-panel/static-1.18883",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3889",
  "partner-shared-messages-lib": "/partner-shared-messages-lib/static-1.12659",
  "ql-visibility-lib": "/ql-visibility-lib/static-1.3967",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2056",
  "guided-selling-core": "/guided-selling-core/static-1.4407",
  "sales-execution-components": "/sales-execution-components/static-1.7545",
  "credit-memos-highlight-card-lib": "/credit-memos-highlight-card-lib/static-1.4942",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3835",
  "policy-lib": "/policy-lib/static-1.5423",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.21930",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.21915",
  "analytics_js": "/analytics_js/static-1.3170",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.17782",
  "feedback-schema": "/feedback-schema/static-1.47911",
  "forms-utils-lib": "/forms-utils-lib/static-1.9955",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.80362",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4097",
  "MeetingsBase": "/MeetingsBase/static-1.54477",
  "outpost": "/outpost/static-1.2961",
  "partner-poi-timeline-event": "/partner-poi-timeline-event/static-1.34270",
  "qualified-leads-embedded-lib": "/qualified-leads-embedded-lib/static-1.41870",
  "quotes-crm-events-lib": "/quotes-crm-events-lib/static-1.36899",
  "react-table": "/react-table/static-1.15",
  "sales-clients-common": "/sales-clients-common/static-1.45092",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5511",
  "sequences-crm-events-lib": "/sequences-crm-events-lib/static-1.22343",
  "settings-ui-nav": "/settings-ui-nav/static-2.8667",
  "social-components-lib": "/social-components-lib/static-1.28355",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3824",
  "ui-tour-react": "/ui-tour-react/static-1.10585",
  "urlinator": "/urlinator/static-1.3167",
  "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.2394",
  "quotes-client-types": "/quotes-client-types/static-1.30890",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2627",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.15543",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.17874",
  "viral-links-lib": "/viral-links-lib/static-1.5486",
  "media-bridge-lib": "/media-bridge-lib/static-1.16427",
  "video-data-lib": "/video-data-lib/static-1.28793",
  "FileManagerImages": "/FileManagerImages/static-1.30932",
  "trellis-story-utils": "/trellis-story-utils/static-1.3178",
  "knowledge-content-types": "/knowledge-content-types/static-1.7617",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8548",
  "in-meeting-experience-client-types": "/in-meeting-experience-client-types/static-1.13125",
  "content-embed-lib": "/content-embed-lib/static-1.5977",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2641",
  "remote-ui": "/remote-ui/static-1.39",
  "ui-extensions": "/ui-extensions/static-1.14361",
  "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.11954",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1559",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8703",
  "immutable-less": "/immutable-less/static-1.3183",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2820",
  "markdown-it": "/markdown-it/static-1.6",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6845",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11023",
  "dashboard-lib": "/dashboard-lib/static-1.75073",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7274",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.7407",
  "html-to-image": "/html-to-image/static-1.29",
  "reporting-plugins": "/reporting-plugins/static-1.6405",
  "reporting-reports": "/reporting-reports/static-1.60652",
  "data-token-picker": "/data-token-picker/static-1.13816",
  "navigation-messaging": "/navigation-messaging/static-1.2856",
  "attribution-lib": "/attribution-lib/static-1.36970",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.6974",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5285",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3771",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2414",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.4950",
  "idb-keyval": "/idb-keyval/static-1.20",
  "simple-logging-lib": "/simple-logging-lib/static-1.1666",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.7258",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5675",
  "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2550",
  "crm-cards-test-utils": "/crm-cards-test-utils/static-1.37249",
  "renewal-center-service-types": "/renewal-center-service-types/static-1.2802",
  "submissions-lib": "/submissions-lib/static-1.40863",
  "ui-forms-components": "/ui-forms-components/static-1.7950",
  "portal-details-components": "/portal-details-components/static-1.13361",
  "ui-extensions-plugin-flywheel": "/ui-extensions-plugin-flywheel/static-1.8895",
  "ui-product-approvals": "/ui-product-approvals/static-1.23398",
  "customer-success-client-types": "/customer-success-client-types/static-1.14073",
  "sales-enablement-lib": "/sales-enablement-lib/static-1.11188",
  "sales-leader-insights-components-lib": "/sales-leader-insights-components-lib/static-1.12892",
  "guided-actions-lib": "/guided-actions-lib/static-1.14046",
  "framework-scoring-client-types": "/framework-scoring-client-types/static-1.10858",
  "fsm": "/fsm/static-1.2322",
  "card-bet-associated-companies-lib": "/card-bet-associated-companies-lib/static-1.71081",
  "card-bet-deal-support-requests-lib": "/card-bet-deal-support-requests-lib/static-1.61822",
  "card-bet-quotes-lib": "/card-bet-quotes-lib/static-1.71088",
  "card-deal-splits-lib": "/card-deal-splits-lib/static-1.38361",
  "card-flywheel-ql-summary-lib": "/card-flywheel-ql-summary-lib/static-1.39968",
  "card-flywheel-recent-conversions-lib": "/card-flywheel-recent-conversions-lib/static-1.39969",
  "card-invoices-lib": "/card-invoices-lib/static-1.50460",
  "card-marketing-event-about-lib": "/card-marketing-event-about-lib/static-1.50242",
  "card-marketing-event-activity-lib": "/card-marketing-event-activity-lib/static-1.50241",
  "card-prospecting-notes": "/card-prospecting-notes/static-1.32259",
  "card-qualified-leads-lib": "/card-qualified-leads-lib/static-1.71243",
  "card-sfdcsync-lib": "/card-sfdcsync-lib/static-1.50312",
  "card-workflows-lib": "/card-workflows-lib/static-1.67258",
  "integrations-sync-card-ui": "/integrations-sync-card-ui/static-1.21287",
  "partner-poi-crm-card": "/partner-poi-crm-card/static-1.13714",
  "recording-preview-card": "/recording-preview-card/static-1.11135",
  "ui-sales-order-wizard-card": "/ui-sales-order-wizard-card/static-1.26271",
  "predictive-scores-lib-components": "/predictive-scores-lib-components/static-1.22509",
  "process-guide-chirp": "/process-guide-chirp/static-1.3200",
  "gapi-client-types": "/gapi-client-types/static-1.3",
  "google-picker-types": "/google-picker-types/static-1.3",
  "ui-google-drive-picker": "/ui-google-drive-picker/static-1.730",
  "deep-diff": "/deep-diff/static-1.5",
  "academy-service-client": "/academy-service-client/static-1.2688",
  "zustand": "/zustand/static-1.45",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.13425",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.7640",
  "cms-field-types": "/cms-field-types/static-1.3403",
  "content-icons-ui": "/content-icons-ui/static-1.1863",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.6725",
  "fintech-buying-service-clients": "/fintech-buying-service-clients/static-1.2357",
  "account-and-billing-contacts-usage": "/account-and-billing-contacts-usage/static-2.17552",
  "emoji-regex": "/emoji-regex/static-1.7",
  "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.9997",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2704",
  "buying-experience-components": "/buying-experience-components/static-1.8427",
  "checkout-service-types": "/checkout-service-types/static-1.2792",
  "growth-pro-utils-lib": "/growth-pro-utils-lib/static-1.7704",
  "audio-components": "/audio-components/static-1.4236",
  "video-components": "/video-components/static-1.7145",
  "video-embed": "/video-embed/static-1.29634",
  "conversations-calling-message": "/conversations-calling-message/static-1.53878",
  "crm-events-viz-test-utils": "/crm-events-viz-test-utils/static-1.16550",
  "crm-pipeline-events-ui": "/crm-pipeline-events-ui/static-1.21909",
  "conversations-routing-lib": "/conversations-routing-lib/static-1.5603",
  "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4386",
  "data-ops-fullstory": "/data-ops-fullstory/static-1.3948",
  "re-reselect": "/re-reselect/static-1.4",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6672",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4505",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4502",
  "automation-ui-core": "/automation-ui-core/static-2.15296",
  "automation-ui-permissions": "/automation-ui-permissions/static-1.13658",
  "workspace-components": "/workspace-components/static-1.2608",
  "settings-content-modals": "/settings-content-modals/static-1.39225",
  "forms-ai-lib": "/forms-ai-lib/static-1.2034",
  "react-tinymce": "/react-tinymce/static-1.49962",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1292",
  "tinymce-config": "/tinymce-config/static-2.49088",
  "meetings-client-types": "/meetings-client-types/static-1.2680",
  "messaging-types-lib": "/messaging-types-lib/static-1.39693",
  "apps-service-types": "/apps-service-types/static-1.2816",
  "oauth-service-types": "/oauth-service-types/static-1.2926",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6540",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.2138",
  "stripe-connect-js": "/stripe-connect-js/static-1.37",
  "customer-data-sidebar-test-utils": "/customer-data-sidebar-test-utils/static-1.34959",
  "form-builder-ui": "/form-builder-ui/static-1.7724",
  "user-configuration-lib": "/user-configuration-lib/static-1.23956",
  "ui-deal-management-components-lib": "/ui-deal-management-components-lib/static-1.15170",
  "ui-signature-editor": "/ui-signature-editor/static-1.13238",
  "immerable": "/immerable/static-1.2790",
  "social-insights-client-types": "/social-insights-client-types/static-1.17259",
  "automation-ui-routing": "/automation-ui-routing/static-1.14720",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.12442",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.2887",
  "access-control-lib": "/access-control-lib/static-1.9094",
  "EmailComponents": "/EmailComponents/static-1.48369",
  "EmailData": "/EmailData/static-1.47045",
  "redux-less": "/redux-less/static-2.8056",
  "tinymce-themes": "/tinymce-themes/static-1.51058",
  "interframe": "/interframe/static-3.3422",
  "tinymce-data": "/tinymce-data/static-1.35173",
  "tinymce-plugins": "/tinymce-plugins/static-1.52202",
  "ContentData": "/ContentData/static-1.62666",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1408",
  "layout-dnd-components": "/layout-dnd-components/static-1.10560",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9535",
  "app-users-service-client": "/app-users-service-client/static-1.3657",
  "app-users-service-types": "/app-users-service-types/static-1.3063",
  "framework-listing-lib": "/framework-listing-lib/static-2.21704",
  "mini-checkout-client": "/mini-checkout-client/static-1.23835",
  "onboarding-utils": "/onboarding-utils/static-1.3968",
  "ContentComponents": "/ContentComponents/static-2.65547",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.39957",
  "ui-tool-access": "/ui-tool-access/static-1.8670",
  "automation-ui-types": "/automation-ui-types/static-1.13360",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8083",
  "codemirror": "/codemirror/static-5.69",
  "react-codemirror": "/react-codemirror/static-1.9224",
  "layout-data-lib": "/layout-data-lib/static-1.7860",
  "framework-listing-lib-shared-msw-handlers": "/framework-listing-lib-shared-msw-handlers/static-1.6738",
  "touchless-buying-components": "/touchless-buying-components/static-1.3069",
  "merchandise-lib": "/merchandise-lib/static-1.221",
  "data-token-views": "/data-token-views/static-1.13797",
  "simple-menus-core": "/simple-menus-core/static-1.13333",
  "simple-menus-lib": "/simple-menus-lib/static-1.14851",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.27656",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.4737",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.2462",
  "ContentEditorUI": "/ContentEditorUI/static-2.70990",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2791",
  "web-interactives-components": "/web-interactives-components/static-1.11238",
  "web-interactives-data": "/web-interactives-data/static-1.11239",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "checkout-sdk": "/checkout-sdk/static-3.20678",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2544",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "backbone": "/backbone/static-1.6",
  "content-management-data-lib": "/content-management-data-lib/static-1.3676",
  "copilot-plugins": "/copilot-plugins/static-1.5576",
  "cta-picker": "/cta-picker/static-1.30704",
  "editor-components": "/editor-components/static-1.11642",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.6921",
  "error-messaging-js": "/error-messaging-js/static-1.3913",
  "pictos": "/pictos/static-7.158",
  "redux-request-state": "/redux-request-state/static-1.9199",
  "smart-content-core": "/smart-content-core/static-1.36658",
  "smart-content-lib": "/smart-content-lib/static-1.37311",
  "social-composer-lib": "/social-composer-lib/static-1.52772",
  "structured-content-lib": "/structured-content-lib/static-1.19586",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.47229",
  "tinymce-copilot": "/tinymce-copilot/static-1.11156",
  "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.31143",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.5699",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.602",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "jquery": "/jquery/static-3.6",
  "ai-rendering-library": "/ai-rendering-library/static-1.4438",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.7823",
  "fuzzy": "/fuzzy/static-1.8",
  "codemirror-dlb": "/codemirror-dlb/static-1.52544",
  "redux-undo": "/redux-undo/static-1.10",
  "highlight.js": "/highlight.js/static-1.45"
}
};
